import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "dropdown" }
const _hoisted_2 = {
  class: "user-menu__trigger",
  type: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false",
  "aria-label": "Abrir menú de usuario",
  title: "Menú de usuario"
}
const _hoisted_3 = {
  class: "user-menu__avatar",
  "aria-hidden": "true"
}
const _hoisted_4 = {
  key: 0,
  class: "user-menu__name"
}
const _hoisted_5 = {
  key: 1,
  class: "fa-solid fa-chevron-down user-menu__chevron",
  "aria-hidden": "true"
}
const _hoisted_6 = { class: "dropdown-menu dropdown-menu-end user-menu__dropdown" }
const _hoisted_7 = { class: "user-menu__identity" }
const _hoisted_8 = { key: 0 }

import { computed } from 'vue'
import type { AuthUser } from '@/store'


export default /*@__PURE__*/_defineComponent({
  __name: 'UserMenu',
  props: {
    user: {},
    showLabel: { type: Boolean, default: true }
  },
  emits: ["logout"],
  setup(__props: any) {

const props = __props



const displayName = computed(() => {
  const name = props.user?.full_name?.trim()
  if (name) return name
  return props.user?.email?.split('@')[0] || 'Usuario'
})

const initials = computed(() => displayName.value
  .split(/\s+/)
  .slice(0, 2)
  .map((part) => part.charAt(0).toUpperCase())
  .join(''))

const company = computed(() =>
  props.user?.organization?.trim() ||
  props.user?.receipt_profile?.business_name?.trim() ||
  props.user?.receipt_profile?.legal_name?.trim() ||
  ''
)

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(initials.value), 1),
      (_ctx.showLabel)
        ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(displayName.value), 1))
        : _createCommentVNode("", true),
      (_ctx.showLabel)
        ? (_openBlock(), _createElementBlock("i", _hoisted_5))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("ul", _hoisted_6, [
      _createElementVNode("li", _hoisted_7, [
        _createElementVNode("strong", null, _toDisplayString(displayName.value), 1),
        (company.value)
          ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(company.value), 1))
          : _createCommentVNode("", true)
      ]),
      _cache[4] || (_cache[4] = _createElementVNode("li", null, [
        _createElementVNode("hr", { class: "dropdown-divider" })
      ], -1)),
      _createElementVNode("li", null, [
        _createVNode(_component_router_link, {
          class: "dropdown-item",
          to: "/perfil"
        }, {
          default: _withCtx(() => _cache[1] || (_cache[1] = [
            _createElementVNode("i", {
              class: "fa-solid fa-user",
              "aria-hidden": "true"
            }, null, -1),
            _createTextVNode(" Mi perfil ")
          ])),
          _: 1,
          __: [1]
        })
      ]),
      _createElementVNode("li", null, [
        _createVNode(_component_router_link, {
          class: "dropdown-item",
          to: "/perfil"
        }, {
          default: _withCtx(() => _cache[2] || (_cache[2] = [
            _createElementVNode("i", {
              class: "fa-solid fa-sliders",
              "aria-hidden": "true"
            }, null, -1),
            _createTextVNode(" Configuración personal ")
          ])),
          _: 1,
          __: [2]
        })
      ]),
      _cache[5] || (_cache[5] = _createElementVNode("li", null, [
        _createElementVNode("hr", { class: "dropdown-divider" })
      ], -1)),
      _createElementVNode("li", null, [
        _createElementVNode("button", {
          class: "dropdown-item text-danger",
          type: "button",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('logout')))
        }, _cache[3] || (_cache[3] = [
          _createElementVNode("i", {
            class: "fa-solid fa-right-from-bracket",
            "aria-hidden": "true"
          }, null, -1),
          _createTextVNode(" Cerrar sesión ")
        ]))
      ])
    ])
  ]))
}
}

})